import { Link } from "react-router";

export function NotFoundPage() {
  return (
    <main className="mx-auto max-w-lg p-10 text-center">
      <h1 className="text-2xl font-semibold">Página no encontrada</h1>
      <p className="mt-2 text-slate-600">La dirección no existe.</p>
      <Link to="/dashboard" className="btn-secondary mt-6">
        Ir al panel
      </Link>
    </main>
  );
}
